import { writable } from "svelte/store";
import * as authApi from "../apis/auth.api";
import { push } from "svelte-spa-router";

export const login_id = writable("");

export async function apiGetStatus() {
    try {
        const response = await authApi.apiGetStatus();

        if (response.status === 200) {
            if (response.data.code === 200) {
                login_id.update(() => response.data.data.as_login_id);

                if (location.href.includes("login")) {
                    push("/Menu");
                }
            } else {
                if (!location.href.includes("login")) {
                    push("/login");
                }
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiPostlogin(as_login_id, as_password) {
    try {
        const formData = {
            as_login_id: as_login_id,
            as_password: as_password,
        };

        const response = await authApi.apiPostlogin(formData);

        if (response.status === 200) {
            if (response.data.code === 200) {
                push("/Menu");
            } else {
                alert(response.data.msg);
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiGetLogout() {
    try {
        const response = await authApi.apiGetLogout();

        if (response.status === 200) {
            if (response.data.code === 200) {
                push("/login");
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}
